<template>
    <div class="card">
        <div class="card-header bg-gray">
            <h3 class="card-title"><i class="fab fa-telegram-plane mr-2"></i>{{ $t('general.enviodemensajes') }}
                
            </h3>
                        <div class="card-tools d-flex align-items-center" v-show="mostrarminimizaraux">
                            <button type="button" id="botonmin" class="btn btn-tool ampliar-asegurado" data-card-widget="collapse" @click="minimizarpulsar" title="Minimizar">
                    <i class="fas fa-eye"></i>
                </button>

                        </div>

        </div>
        <div class="card-body">

            <!--INICIO LISTA GREMIOS-->
            <div class="row" v-if="gremios" :class="clasegremio">
                <div class="col-md-12">
                    <table class="table table-striped table-valign-middle">
                        <thead>
                            <tr>
                                <th v-for="columna in gremios.gremios.encabezado" :key="columna">{{ columna }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="filas in gremios.gremios.filas" :key="filas">
                                <td style="padding:0.3rem" v-for="fila in filas" :key="fila">
                                    <div v-if="fila.campos">
                                        <div v-for="(campo, index) in fila.campos" :key="campo">
                                            <label style="margin-bottom:0rem;vertical-align:top" class="btn active"
                                                v-if="campo.tipo == 'radio'">
                                                <input @click="seleccionarGremio(campo.valor,fila)" class="defecto"
                                                    v-if="campo.valor == fila.campos[0].valor" type="radio"
                                                    name="opcionesGremio" :id="campo.valor" autocomplete="off" />
                                                <input @click="seleccionarGremio(campo.valor,fila)"
                                                    :class="'prestacion' + index"
                                                    style="margin-bottom:0rem;vertical-align:top" v-else type="radio"
                                                    name="opcionesGremio" :id="campo.valor" autocomplete="off" />
                                                {{ campo.desc }}
                                            </label>
                                            <label class="btn active" v-else-if="campo.desc && campo.tipo == 'button'">
                                                <button style="font-size:0.7em" type="button"
                                                    v-if="campo.desc == 'Actualizar'"
                                                    @click="actualizarPrestacion(filas.columna1.campos[0].valor, index);"
                                                    class="btn btn-secondary">
                                                    <i class="fas fa-sync"> {{ campo.desc }}</i>
                                                </button>
                                            </label>
                                        </div>
                                    </div>
                                    <div v-if="!fila.campos">
                                        <p style="margin-bottom: 0px;" v-html="fila"></p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div><!--FIN TABLA LISTA GREMIOS-->
            <div v-if="tipocargado != 'defecto'">
              
                    <iframe :src="direccioncomputed" width="100%" height="615px"  frameborder="0"  ></iframe>
            
                </div> 
            <div v-if="spinner == true" class="spinners"></div>
            <div :class="spinner == true ? 'difuminado' : ''"  v-if="tipocargado == 'defecto'">
                <!--INICIO SELECT TIPO ENVIO-->
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                                <label for="exampleInputEmail1">{{ $t('general.tipodeenvio') }}</label><br>
                                <select @change="cargarTipoenvio()"
                                    class="custom-select form-control-sm exampleInputEmail1 select2"
                                    v-model="tipoenvioseleccionado"><!--watch tipoenvioseleccionado-->
                                    <option v-for="mensajes in tiposenvio" :key="mensajes.nombre" :value="mensajes"
                                        :title="mensajes.title" :disabled="mensajes.disabled == 1">
                                        {{ mensajes.nombre }}
                                    </option>
                                </select>
                                <div v-if="tipoenvioseleccionado && tipoenvioseleccionado.title">
                                    <p style="font-size: small;">{{ tipoenvioseleccionado.title }}</p>
                                </div>
                        </div>
                    </div>
                </div>
                 <!--FIN SELECT TIPO ENVIO-->
                <!--INICIO SECCION FORMULARIO-->
                <div class="form-group" >
                    <!--INICIO CAMPOS-->
                    <div :style="estilocampos(campo.tipo, campo.saltolinea, campo.desc)"
                        v-for="campo in tipoenvioseleccionado.campos" :name="campo.desc" :class="campo.desc"
                        :key="campo.desc" :id="'form' + index">

                        <span v-if="campo.tipo == 'radio'">
                            &nbsp;
                            <input
                            type="radio"
                            :name="campo.nombre"
                            :value="campo.valor"
                            v-model="radiosseleccionados[campo.nombre]"
                            autocomplete="off"
                            @change="comprobarCampoPendiente(campo.actualizar)"
                            />
                        </span>

                        <label :style="estilolabel(campo.tipo)" :for="campo.nombre">{{ campo.desc }}</label>

                        <span v-if="campo.tipo == 'select'">
                            <select :disabled="campo.disabled == 'disabled'" @change="comprobarCampoPendiente(campo.actualizar)"
                                :class="'custom-select form-control ' + campo.nombre" v-model="campo.valor">
                                <option value="" selected hidden>Seleccione opción</option>
                                <option v-for="opcion in campo.valores" :key="opcion.valor" :value="opcion.valor">{{ opcion.texto }}</option>
                            </select>
                        </span>

                        <span v-if="campo.tipo == 'text'">
                            <input :disabled="campo.disabled == 'disabled'" type="text" v-model="campo.valor"
                                :class="'form-control ' + campo.nombre" />
                        </span>

                        <span v-if="campo.tipo == 'checkbox'">
                            <input :true-value="1" :false-value="0"
                                :disabled="mensajes && mensajes.disabled == 'disabled'" type="checkbox"
                                :class="'custom-checkbox ' + campo.nombre" v-model="campo.valor" />

                        </span>

                        <span v-if="campo.tipo == 'img'">
                            <img :src="campo.src" style="width:150px">
                        </span>

                        <span v-if="campo.tipo == 'textarea' && campo.editor_html == '1'">
                            <Editor :id="campo.nombre" @input="sacarlongitud(campo.nombre)"
                                @keydown="onKeyDown($event, campo.valor, campo.condiciones.maxLength)"
                                editorStyle="height: 160px" :v-model="campo.valor"
                                v-if="campo.condiciones && campo.condiciones.maxLength">
                            </Editor>
                            <Editor editorStyle="height: 160px" v-model="campo.valor" v-else>
                            </Editor>
                            <label v-if="campo.condiciones && campo.condiciones.maxLength">{{
                                longitud[campo.nombre] }}/{{ campo.condiciones.maxLength }}
                                Caracteres</label>
                        </span>



                        <span v-if="campo.tipo == 'textarea' && campo.editor_html != '1'">

                            <textarea :id="campo.nombre"
                                @input="sacarlongitud(campo.nombre); campo.valor = sacarvalor(campo.nombre)"
                                @keydown="onKeyDown($event, campo.nombre, campo.condiciones.maxLength)"
                                v-model="campo.valor" :disabled="campo.disabled == 'disabled'"
                                v-if="campo.condiciones && campo.condiciones.maxLength"
                                :class="'form-control ' + campo.nombre"></textarea>

                            <textarea :id="campo.nombre" v-model="campo.valor"
                                @input="campo.valor = sacarvalor(campo.nombre)" :disabled="campo.disabled == 'disabled'"
                                v-else :class="'form-control ' + campo.nombre"></textarea>

                            <label v-if="campo.condiciones && campo.condiciones.maxLength">
                                {{ longitud[campo.nombre] }} /{{ campo.condiciones.maxLength
                                }} Caracteres
                            </label>


                        </span>

                        <span v-if="campo.tipo == 'date'">

                            <!--    <input :disabled="campo.disabled == 'disabled'" type="date" v-model="campo.valor"
                                :class="'form-control ' + campo.nombre" />-->
                            <Calendar :disabled="campo.disabled == 'disabled'" @date-select="campo.modificada = true" showOtherMonths="true" selectOtherMonths="true"
                                dateFormat="dd/mm/yy" v-model="campo.valor" />

                        </span>

                        <!--INICIO SECCION DOCUMENTOS-->

                        <div v-if="Object.keys(campo) == 'documentos' && campo.documentos[1]">
                            <Button @click="cargardocumentos()" type="button" class="btn btn-info">{{
                                $t('general.documentos') }}</button>
                            <br>

                            <Dialog v-show="mostrardialogo" header="Documentos" v-model:visible="mostrardialogo" modal
                                :style="{ width: '80vw' }" @click="console.log(documentos, documentosanyadidos)">       
                                <div style="display: grid; gap: 20px;">
                                    <div v-for="visita in documentos" :key="visita.id_visita">
                                       <h4 v-if="visita.operario ==''">Archivos del servicio</h4>
                                        <h4 v-else>{{ visita.fecha }} - {{ visita.operario }}</h4>
                                        <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px;">
                                            <div v-for="documento in visita.documentos" :key="documento.id_documento"                                                
                                                style="margin-left:40px;display: flex; flex-direction: column; align-items: center; justify-content: space-between; height: 220px;">
                                                
                                                <select :disabled="idsdocsanyadidos.includes(documento.id_documento)" @change="asociardocumento(documento);"
                                                    :class="'custom-select form-control ' + campo.documentos[0].nombre"
                                                    v-model="documento.valor" style="width: fit-content; height: 30px;">
                                                    <option :value="documento.valor" disabled selected hidden>
                                                        Seleccione</option>
                                                    <option v-for="opcion in campo.documentos[0].valores" :key="opcion.valor"
                                                        :value="opcion.valor" :disabled="opcion.texto == 'FOTOGRAFIAS'" :title="opcion.texto == 'FOTOGRAFIAS'?'Las fotografías a Caser se deben de enviar generando un informe fotográfico desde la pestaña de Informe fotográfico':''">
                                                        {{ opcion.texto }}
                                                    </option>
                                                </select>
                                                <div v-if="documento.cuando">
                                                    <span style="width: 150px;" v-if="documento.cuando == 'despues'"
                                                        class="badge bg-blue">después</span>
                                                    <span style="width: 150px;" v-else class="badge bg-blue">{{
                                                        documento.cuando }}</span>
                                                </div>
                                                <div v-if="documento.documento.substring(documento.documento.length - 3) == 'jpg' || documento.documento.substr(documento.documento.length - 3) == 'png' || documento.documento.substr(documento.documento.length - 4) == 'jpeg' || documento.documento.substr(documento.documento.length - 3) == 'bmp' || documento.documento.substr(documento.documento.length - 3) == 'gif' || documento.documento.substr(documento.documento.length - 4) == 'tiff' || documento.documento.substr(documento.documento.length - 4) == 'webp'">

                                                </div>
                                                <div style="width: fit-content; margin-top: 5px" v-else>
                                                    <span>{{ documento.descripcion }}</span>
                                                </div>
                                                <div v-if="documento.documento.substring(documento.documento.length - 3) == 'jpg' || documento.documento.substr(documento.documento.length - 3) == 'png' || documento.documento.substr(documento.documento.length - 4) == 'jpeg' || documento.documento.substr(documento.documento.length - 3) == 'bmp' || documento.documento.substr(documento.documento.length - 3) == 'gif' || documento.documento.substr(documento.documento.length - 4) == 'tiff' || documento.documento.substr(documento.documento.length - 4) == 'webp'">
                                                    <img style="width: 150px; height: 160px;" v-if="urlglobal != 'null.pwgs.app'"
                                                    :src='documento.url_completa_descarga' width="150" preview
                                                    :title="documento.descripcion" />
                                                    <img style="width: 150px; height: 160px;" v-else-if="urlglobal == 'null.pwgs.app'"
                                                        :src='"https://desarrollo.pwgs.app/" + documento.url_descarga' width="150"
                                                        preview :title="documento.descripcion" />
                                                </div>
                                                <div style="display: grid" v-else>
                                                    <i class="fas fa-file-pdf" style="font-size:160px;"></i>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>                         
                            </Dialog>
                        </div>


                        <!--FIN SECCION DOCUMENTOS-->

                    </div><!--FIN CAMPOS-->
                    <ul style="list-style-type: none;">
                        <li v-for="documento in documentosanyadidos" :key="documento.id_documento">
                            <p><button @click="eliminardocumento(documento)"
                                    class="p-button p-component p-button p-component p-button-icon-only p-button-danger p-button-rounded p-button-text"
                                    type="button" aria-label="Cancel" data-pc-name="button" data-pc-severity="danger"
                                    data-pc-section="root"><span class="p-button-icon pi pi-times"
                                        data-pc-section="icon"></span></button>{{
                                documento.documento }}&nbsp;({{
                                documento.valor }})</p>
                        </li>
                    </ul>
                    <button class="btn btn-success btn-block" @click="enviarComunicacion()" :disabled="enviando" type="button">{{enviando?'Enviando...': $t('general.enviar') }}</button>
                </div><!--FIN SECCION FORMULARIO-->
            </div><!--FIN SPINNER-->
        </div><!--FIN CARD BODY-->
    </div><!--FIN CARD-->
</template>
<script>
import Editor from 'primevue/editor';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';

import { PwgsApi } from '../../../../../services/PwgsApi';
export default ({
    props: ['id','servicio','minimizarprop','tipocargado'],
    data() {
        return {
            idcargado: '',
            idsdocsanyadidos: [],
            enviando: false,
            gremios: '',
            gremioseleccionado: '',
            comunicacionessistema: '',
            tiposenvio: '',
            tipoenvioseleccionado: '',
            nombretipoenvioseleccionado: '',
            keytipoenvioseleccionado: '',
            spinner: false,
            id_comunicacion: '',
            longitud: [],
            documentos: [],
            mostrardialogo: false,
            urlglobal: '',
            documentosanyadidos: [],
            singremio: false,
            radiosseleccionados:[],
            repetiraux:0,
            direccionglobal:  localStorage.getItem('direccion'),
             

        }
    },

    components: {
        Editor, Dialog, Button,Calendar
    },
    methods: {

        vaciardatos() {
            this.gremios = '';
            this.gremioseleccionado = '';
            this.comunicacionessistema = '';
            this.tiposenvio = '';
            this.tipoenvioseleccionado = '';
            this.nombretipoenvioseleccionado = '';
            this.keytipoenvioseleccionado = '';


        },
        minimizarpulsar(){
            if(this.repetiraux==0){
                            this.$parent.$parent.minimizar();
                            this.repetiraux=1;

            }
            setTimeout(() => {
                this.repetiraux=0;
            }, 500);
        },
        quitardocumentolista(doc){
            delete this.documentos[doc.id_documento];
        },
        formatearDate(fecha) {
            let date = new Date(fecha);
            let day = date.getDate();
            let month = date.getMonth() + 1; // Add 1 because getMonth() returns 0-11
            let year = date.getFullYear();
            if(day < 10){
                day = '0' + day;
            }
            if(month < 10){
                month = '0' + month;
            }
            let formattedDate = `${day}/${month}/${year}`;
            if (isNaN(date)) {
                console.log("fecha1", fecha);

                return fecha;
            }
            if(!isNaN(date)){
                console.log("fecha2", fecha);
                return formattedDate;

            }

        },
        async actualizarPrestacion(idipas, indice) {
            //index.php/servicios/:id/prestacion-ipas/:n_prestacion_ipas
            const api = new PwgsApi();
            if (confirm('¿Desea actualizar la prestación ' + idipas + '?')) {
                try {
                    await api.put('servicios/' + this.$props.id + '/prestacion-ipas/' + idipas);
                    this.cargarGremios(indice);
                }
                catch (e) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });

                }

            }

        },
        async cargardocumentos() {
            this.urlglobal = localStorage.getItem('direccion');
            // GET:  modulos/pwgsapi/index.php/servicios/:id/documentos
            const api = new PwgsApi();
            try {
                var documentosaux = await api.get('servicios/' + this.$props.id + '/documentos');
                this.documentos = [];
                for(let documento of Object.values(documentosaux)){
                    if(documento.documento.substring(0, 15) != 'firma_operario_'){
                        var encontrado = '';
                        if(this.documentos.length == 0){
                            this.documentos.push({
                                idvisita: documento.visitadores_idvisitador,
                                fecha: documento.fecha_visita,
                                operario: documento.operario,
                                documentos: [documento]
                            });
                        }else{
                            encontrado = this.documentos.find(doc => doc.idvisita == documento.visitadores_idvisitador);                        
                            if(encontrado == undefined){
                                this.documentos.push({
                                    idvisita: documento.visitadores_idvisitador,
                                    fecha: documento.fecha_visita,
                                    operario: documento.operario,
                                    documentos: [documento]
                                });
                            }else{
                                encontrado.documentos.push(documento);
                            }
                        }
                    }
                        
                }
                console.log('documentos', this.documentos);
            }
            catch (e) {
                console.log(e);
                setTimeout(() => {
                    document.getElementsByClassName("defecto")[0].click();
                }, 500);
            }
            this.mostrardialogo = true;
        },
        async asociardocumento(archivo) { /* Prepara los documentos seleccionados en un array para enviarlos*/
            if(this.idsdocsanyadidos.includes(archivo.id_documento)){
                console.log('incluye')
            }else{
                console.log('no incluye')
            }
            console.log('archivo', archivo);
            const api = new PwgsApi();
            var axa = await api.get('servicios/' + this.$props.id + '/sistema-axa');
            console.log('axa', axa);
            if(this.documentosanyadidos.length>0 && axa=='SI'){
                alert('Solo puede adjuntar un documento');
            }else{
                this.idsdocsanyadidos.push(archivo.id_documento);
                this.documentosanyadidos.push(archivo);
            }
        },
        eliminardocumento(doc) {/*Elimina el documento del array del envio*/
            this.documentosanyadidos.splice(this.documentosanyadidos.indexOf(doc), 1);
            this.idsdocsanyadidos.splice(this.idsdocsanyadidos.indexOf(doc.id_documento), 1);
        },
        async enviarComunicacion() {/* ENVIA LA COMUNICACION (boton enviar comunicacion)*/
            this.enviando = true;
            console.log('this.tipoenvioseleccionado', this.tipoenvioseleccionado);
            let subidadatos = {};
            this.keytipoenvioseleccionado = this.getKeyByValue(this.comunicacionessistema.tipos_mensajes, this.tipoenvioseleccionado);
            let aux = {};           
            subidadatos['tipo_mensaje'] = this.keytipoenvioseleccionado;
            aux['id_gremio'] = this.gremioseleccionado;
            if (this.nombretipoenvioseleccionado == 'Responder Diálogo') {
                aux['id_comunicacion'] = this.id_comunicacion;
            }
            for (let i = 0; i < this.tipoenvioseleccionado.campos.length; i++) {
                console.log('llega', this.tipoenvioseleccionado);
                if (this.tipoenvioseleccionado.campos[i].tipo == "date") {
                    if (this.tipoenvioseleccionado.campos[i].modificada == true) {
                        aux[this.tipoenvioseleccionado.campos[i].nombre] = this.formatearDate(this.tipoenvioseleccionado.campos[i].valor);
                    }
                    else {
                        aux[this.tipoenvioseleccionado.campos[i].nombre] = this.tipoenvioseleccionado.campos[i].valor;

                    }

                }
                else {
                    if (this.tipoenvioseleccionado.campos[i].tipo == "radio") {
                        aux[this.tipoenvioseleccionado.campos[i].nombre] = this.radiosseleccionados[this.tipoenvioseleccionado.campos[i].nombre];
                    }else{
                        aux[this.tipoenvioseleccionado.campos[i].nombre] = this.tipoenvioseleccionado.campos[i].valor;
                    }
                }
            }
            /**AÑADIR DOCUMENTOS**/
            if (this.documentosanyadidos.length > 0) {
                if(aux["TipoGestDoc"] && aux["TipoGestDoc"]=="ADD_DOC"){
                    aux["NombreDoc"] = this.documentosanyadidos[0].documento;
                }
                aux["documentos"] = [];
                for (let j = 0; j < this.documentosanyadidos.length; j++) {
                    aux["documentos"].push({
                        tipo_archivo: this.documentosanyadidos[j].valor,
                        nombre_documento: this.documentosanyadidos[j].documento
                    });
                }
            }
            /**FIN AÑADIR DOCUMENTOS**/
            subidadatos["campos"] = aux;
            
            const api = new PwgsApi();
            if(subidadatos.campos.TipoOperacion == "/SIN_INTERV"){
                console.log('gremioseleccionado', this.gremioseleccionado);
                //mirar si el oficio tiene las fechas planificadas, si no las tiene pasará a anularse en lugar de cerrarse
                console.log('sii');
                const datosGremio = await api.post('servicios/'+this.gremioseleccionado+'/datos-gremio');
                console.log('datosGremio', datosGremio);
                const indice = datosGremio.Indice;
                const especialidad = datosGremio.IdEspecialidad;
                const datosServicio = await api.post('servicios/' + this.$props.id+'/datos-axa');
                var fechaInicio = "";
                var fechaFin = "";
                console.log('datosServicio', datosServicio);                
                datosServicio.OficiosPlanifAseguradoList.OficioPlanificado.forEach(oficio => {
                    console.log('oficio', oficio);
                    if(oficio.Indice == indice && oficio.IdEspecialidad == especialidad){
                        fechaInicio = oficio.FechaIniPL;
                        fechaFin = oficio.FechaFinPL;                       
                    }
                })
                if(fechaInicio == "" || fechaFin == ""){
                    this.enviando = false;
                    this.confirmar(subidadatos);       
                    return;
                }
            }
            if(subidadatos.campos.TipoOperacion == "/CONF_OFIC" && subidadatos.campos.TipoFecha== "FIN"){
                const datosGremio = await api.post('servicios/'+this.gremioseleccionado+'/datos-gremio');
                console.log('datosGremio', datosGremio);
                const indice = datosGremio.Indice;
                const especialidad = datosGremio.IdEspecialidad;
                const idAfectado = datosGremio.IdAfectado;
                const datosServicio = await api.post('servicios/' + this.$props.id+'/datos-axa');
                const datos = await api.post('servicios/' + this.id + '/oficios');
                console.log('datosServicio', datosServicio);
                console.log('especialidad', especialidad);
                console.log('indice', indice);
                console.log('datos', datos);
                var pertenece_presupuesto = false;
                if(datos.Error.CodError && datos.Error.CodError != "0" && datos.Error.CodError != ""){
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: datos.Error.DescError, life: 5000 });
                    this.enviando = false;
                    return;
                }
                if(datos.RepairEstimateValuationList.Presupuestos.ListadoPresupuestos[0].Presupuesto){
                    datos.RepairEstimateValuationList.Presupuestos.ListadoPresupuestos[0].Presupuesto.forEach(presupuesto => {
                        presupuesto.Oficios.forEach(oficio => {
                            if(oficio.IndiceEspecialidad == indice && oficio.IdEspecialidad == especialidad){
                                pertenece_presupuesto = true;
                            }
                        })
                    })
                }
                if(pertenece_presupuesto){
                    console.log('pertenece');
                    this.enviando = false;
                    this.confirmar2(subidadatos, datosServicio);
                    return;
                }
                console.log('no pertenece');
                var oficiosAbiertos = false;
                var destino = 'P';
                for(let oficio of datosServicio.OficiosPlanifAseguradoList.OficioPlanificado){
                    if(idAfectado == oficio.IdAfectado && (oficio.Indice != indice || oficio.IdEspecialidad != especialidad)){
                        console.log('entra1');
                        destino = oficio.Destino;
                        if(oficio.IdEstadoOfic!='' && oficio.IdEstadoOfic != 2  && oficio.IdEstadoOfic != 5 &&  oficio.IdEstadoOfic != 8 &&  oficio.IdEstadoOfic != 9 && oficio.IdEstadoOfic != 10 && oficio.IdEstadoOfic != 1 && oficio.IdEstadoOfic != 4 && oficio.IdEstadoOfic != 6 && oficio.IdEstadoOfic != 3 && oficio.IdEstadoOfic != 7){
                            oficiosAbiertos = true;
                        }
                    }
                }
                if(!oficiosAbiertos){
                    for(let oficio of datosServicio.OficiosPlanifPerjudicadoList.OficioPlanificado){
                        if(idAfectado == oficio.IdAfectado && (oficio.Indice != indice || oficio.IdEspecialidad != especialidad)){
                            console.log('entra2');
                            destino = oficio.Destino;
                            if(oficio.IdEstadoOfic!='' && oficio.IdEstadoOfic != 2 && oficio.IdEstadoOfic != 5 && oficio.IdEstadoOfic != 8 && oficio.IdEstadoOfic != 9 && oficio.IdEstadoOfic != 10 && oficio.IdEstadoOfic != 1 && oficio.IdEstadoOfic != 4 && oficio.IdEstadoOfic != 6 && oficio.IdEstadoOfic != 3 && oficio.IdEstadoOfic != 7){
                                oficiosAbiertos = true;
                            }
                        }
                    }
                }
                // if(!oficiosAbiertos){
                //     for(let oficio of datosServicio.OficiosDispPrimerOficioList.EspecialidadPrimerOficio){
                //         if(oficio.Indice != indice || oficio.IdEspecialidad != especialidad){
                //             console.log('entra3');
                //             destino = oficio.Destino;
                //             if(oficio.IdEstadoOfic!='' && oficio.IdEstadoOfic != 5 && oficio.IdEstadoOfic != 8 && oficio.IdEstadoOfic != 9 && oficio.IdEstadoOfic != 10 && oficio.IdEstadoOfic != 1){
                //                 oficiosAbiertos = true;
                //             }
                //         }
                //     }
                // }
                console.log('oficiosAbiertos', oficiosAbiertos, 'destino', destino);
                if(!oficiosAbiertos && destino == 'P'){
                    this.enviando = false;
                    this.confirmar2(subidadatos, datosServicio);
                    return;
                }
            }
            try {
                console.log('datosdada',subidadatos);
                await api.post('servicios/' + this.$props.id + '/comunicacion-sistema', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Enviada', detail: 'Comunicación enviada correctamente', life: 2000 });
                console.log("parentcomunicaciones", this.$parent);
                this.cargarGremios();
                this.$parent.cargarmensajes();
                this.enviando = false;
            }catch (e) {
                this.enviando = false;
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });

            }

        },
        async enviocomu(subidadatos){
            try{
                subidadatos.campos["TipoOperacion"] = "/ANUL_OFIC";
                const api = new PwgsApi();
                console.log('datosdada',subidadatos);
                await api.post('servicios/' + this.$props.id + '/comunicacion-sistema', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Enviada', detail: 'Comunicación enviada correctamente', life: 2000 });
                console.log("parentcomunicaciones", this.$parent);
                this.$parent.cargarmensajes();
                this.cargarGremios();
                this.enviando = false;
            }catch (e) {
                this.enviando = false;
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async enviocomufinal(subidadatos, valor, causante){
            try{
                subidadatos.campos.IndicadorOrigenAveriaRiesgoAsegurado = causante;
                subidadatos.campos.IndicadorTrabajosFinalizados = valor;
                const api = new PwgsApi();
                console.log('datosdadafinal',subidadatos);
                await api.post('servicios/' + this.$props.id + '/comunicacion-sistema', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Enviada', detail: 'Comunicación enviada correctamente', life: 2000 });
                console.log("parentcomunicaciones", this.$parent);
                this.$parent.cargarmensajes();
                this.cargarGremios();
                this.enviando = false;
            }catch (e) {
                this.enviando = false;
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },

        comprobarAsegurado(subidadatos, datosServicio){
            var responsable = false;
            datosServicio.AfectadosList.Afectado.forEach(afectado => {
                if(afectado.TipoAfectado == 'R'){
                    responsable = true;
                }
            })
            if(responsable){
                this.confirmar3(subidadatos, 'N');
            }else{
                alert('Complete causa y datos del causante en el árbol del siniestro');
                this.enviando = false;
                return;
            }
        },
        confirmar2(subidadatos, datosServicio){
            this.$confirm.require({
                message: '¿El origen de la avería es en el riesgo asegurado?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    console.log('llega1');
                    this.confirmar3(subidadatos, 'S');
                },
                reject: () => {
                    this.comprobarAsegurado(subidadatos, datosServicio);
                    return;
                }
            });
        },
        confirmar3(subidadatos, causante){
            console.log('llega2');
            setTimeout(() => {
                this.$confirm.require({
                    message: '¿Ha finalizado todos sus trabajos?',
                    header: 'Confirmación',
                    icon: 'pi pi-exclamation-triangle',
                    rejectClass: 'p-button-secondary p-button-outlined',
                    rejectLabel: 'Cancelar',
                    acceptLabel: 'Aceptar',
                    accept: () => {
                        this.enviocomufinal(subidadatos, 'S', causante);
                    },
                    reject: () => {
                        this.enviocomufinal(subidadatos, 'N', causante);
                    }
                });
                
            }, 1500);
        },
        confirmar(subidadatos){
            this.$confirm.require({
                message: '¿Al no tener fechas planificadas, el oficio pasará a anularse, desea continuar?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.enviocomu(subidadatos);
                },
                reject: () => {
                    this.enviando = false;
                    return;
                }
            });
        },
        async comprobarCampoPendiente(actualizar) {/*Comprueba si al modificar el campo hay que actualizar los tipos de envio*/

            if (actualizar == 1) {

                let subidadatos = {};
                subidadatos['id_gremio'] = this.gremioseleccionado;
                subidadatos['tipo_mensaje'] = this.keytipoenvioseleccionado;

                if (this.nombretipoenvioseleccionado == 'Responder Diálogo') {/*Si el tipo de envio es responder_dialogo se envia la id de la comunicacion seleccionada*/
                    subidadatos['id_comunicacion'] = this.id_comunicacion;
                }

                for (let i = 0; i < this.tipoenvioseleccionado.campos.length; i++) {
                    if (this.tipoenvioseleccionado.campos[i].tipo == "date") {
                        if (this.tipoenvioseleccionado.campos[i].modificada == true) {
                            subidadatos[this.tipoenvioseleccionado.campos[i].nombre] = this.formatearDate(this.tipoenvioseleccionado.campos[i].valor);
                        }
                        else { 
                            subidadatos[this.tipoenvioseleccionado.campos[i].nombre] = this.tipoenvioseleccionado.campos[i].valor;

                        }

                    }
                    else {
                        subidadatos[this.tipoenvioseleccionado.campos[i].nombre] = this.tipoenvioseleccionado.campos[i].valor;
                    }         
                }
                const api = new PwgsApi();
                this.spinner = true;
                try {
                    this.comunicacionessistema = await api.post('servicios/' + this.$props.id + '/comunicaciones-sistema', subidadatos);
                    if(this.comunicacionessistema && this.comunicacionessistema.tipos_mensajes){
                        this.tiposenvio = this.comunicacionessistema.tipos_mensajes;
                        this.tipoenvioseleccionado = this.comunicacionessistema.tipos_mensajes[this.keytipoenvioseleccionado];
                    }
                }

                catch (e) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });


                }
                this.spinner = false;


            }
        },

        async cargarGremios(indice) {
            //GET  modulos/pwgsapi/index.php/servicios/:id/comunicaciones-gremios
            this.gremios = '';
            const api = new PwgsApi();
            try {
                this.gremios = await api.get('servicios/' + this.$props.id + '/comunicaciones-gremios');
                if (this.gremios == "") {
                    this.singremio = true;
                    this.seleccionarGremio();
                }
                else{
                if (indice && indice != "defecto") {
                    document.getElementsByClassName('prestacion' + indice)[0].click();

                }
                else {
                    setTimeout(() => {
                        document.getElementsByClassName("defecto")[0].click();
                    }, 500);
                }
                 console.log('tiposenvio', this.$props.servicio);

            if(this.tiposenvio == '' && this.$props.servicio.compania.sistema == 'MAPFRE'){
              this.tiposenvio = {
                "INFOGENERALENVIAR":{"nombre":"INFO ENVIADO","campos":[{"nombre":"info","desc":"Mensaje","tipo":"textarea","valor":"","editor_html":"1"}]},
                "INFOGENERALRECIBIR":{"nombre":"INFO RECIBIDO","campos":[{"nombre":"info","desc":"Mensaje","tipo":"textarea","valor":"","editor_html":"1"}]},
            }
            this.tipoenvioseleccionado = this.tiposenvio.INFOGENERALENVIAR;
            }
                }
            }
            catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });


            }
        },
        async seleccionarGremio(valorgremio) {
            //POST  modulos/pwgsapi/index.php/servicios/:id/comunicaciones-sistema
            console.log("valor",valorgremio);
            this.idcargado = valorgremio;
            this.spinner = true;
            this.tipoenvioseleccionado = '';
            this.gremioseleccionado = valorgremio;
            const api = new PwgsApi();
            try{
            this.comunicacionessistema = await api.post('servicios/' + this.$props.id + '/comunicaciones-sistema', { id_gremio: this.gremioseleccionado });
            if(this.comunicacionessistema && this.comunicacionessistema.tipos_mensajes){
                this.tiposenvio = this.comunicacionessistema.tipos_mensajes;
            }
            
            if(this.comunicacionessistema && this.comunicacionessistema.datos && this.comunicacionessistema.datos.envio_defecto){
                this.tipoenvioseleccionado = this.comunicacionessistema.tipos_mensajes[this.comunicacionessistema.datos.envio_defecto];
            }
            }
            catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
            this.spinner = false;
        },
        cargarTipoenvio() { /* Al cambiar el tipo de envio*/
            this.nombretipoenvioseleccionado = this.tipoenvioseleccionado.nombre;
            this.keytipoenvioseleccionado = this.getKeyByValue(this.comunicacionessistema.tipos_mensajes, this.tipoenvioseleccionado);
            this.rellenarTipoEnvio();
        },
        async rellenarTipoEnvio() {
            this.spinner = true;
            const api = new PwgsApi();
            try {
                this.comunicacionessistema = await api.post('servicios/' + this.$props.id + '/comunicaciones-sistema', { id_gremio: this.gremioseleccionado, tipo_mensaje: this.keytipoenvioseleccionado });

            }
            catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
                if (this.singremio == true) {
                    document.getElementsByClassName("defecto")[0].click();
                }
                else { 
                    this.seleccionarGremio();
                }


            }
            this.tiposenvio = this.comunicacionessistema.tipos_mensajes;
            this.tipoenvioseleccionado = this.comunicacionessistema.tipos_mensajes[this.keytipoenvioseleccionado];
            this.spinner = false;
            if (this.nombretipoenvioseleccionado == 'Responder Diálogo') {
                document.getElementsByClassName("defectoresponderdialogo")[0].click();
            }

        },
        async cargarResponderDialogo() {
            this.spinner = true;
            const api = new PwgsApi();
            this.comunicacionessistema = await api.post('servicios/' + this.$props.id + '/comunicaciones-sistema', { id_gremio: this.gremioseleccionado, tipo_mensaje: this.keytipoenvioseleccionado, id_comunicacion: this.id_comunicacion });
            this.tiposenvio = this.comunicacionessistema.tipos_mensajes;
            this.tipoenvioseleccionado = this.comunicacionessistema.tipos_mensajes[this.keytipoenvioseleccionado];
            this.spinner = false;
        },
        getKeyByValue(object, value) {
            return Object.keys(object).find(key => object[key] === value);
        },
        estilocampos(tipo, saltolinea, desc) {
            let auxlinea = 'display:inline-block;margin-bottom:15px'
            /*if (saltolinea == true) {
                auxlinea = "display:block;margin-bottom:10px"
            }*/
            if (tipo == "hidden") {
                return "margin-right:0px;visibility:hidden;" + auxlinea;
            }
            if (tipo == "textarea") {
                return "width:100%;display:inline-block;" + auxlinea;
            }
            if (tipo == "radio") {
                return "width:100%;display:inline-block;" + auxlinea;
            }
            if (tipo == "text") {
                if (desc == "Descripción futura acción") {
                    return "width:100%;display:inline-block;margin-right:20px;" + auxlinea;
                }
                return "display:inline-block;margin-right:20px;" + auxlinea;
            }
            return "width:fit-content;margin-right:20px;" + auxlinea;

        },
        estilolabel(tipo){
            if (tipo == "radio") {
                return "margin-left:10px;display:inline-block;font-size:small;";
            }
            return "display:block;";
        },
        onKeyDown(evt, texto, maximocaracteres) {
            if (maximocaracteres) {
                if (document.getElementById(texto).value.length >= maximocaracteres) {
                    if (evt.keyCode >= 48 && evt.keyCode <= 90) {
                        evt.preventDefault()
                        return
                    }
                }
            }
        },
        sacarlongitud(texto) {
            this.longitud[texto] = document.getElementById(texto).value.length;

        },
        sacarvalor(texto) {
            return document.getElementById(texto).value
        },
        decode_utf8(s) {
            try {
                return decodeURIComponent(escape(s));
            }
            catch (error) {
                console.log(error);
                return s;
            }
        },

    },

    mounted() {
        this.cargarGremios();
        this.idcargado = this.$props.id;

    },
     computed:{
       direccioncomputed(){
        if(this.direccionglobal == 'null.pwgs.app'){
            return "https://desarrollofront.pwgs.app/modulos/multiasistencia/modulo_multiasistencia.php?id_gremio=" + this.idcargado + "&tipo=" + this.$props.tipocargado;
        }
        else{
            return "https://" + this.direccionglobal + "/modulos/multiasistencia/modulo_multiasistencia.php?id_gremio=" + this.idcargado + "&tipo=" + this.$props.tipocargado;
        }
       }
    },
    watch: {
        id() {
            this.vaciardatos();
            this.cargarGremios();

        },
        minimizarprop(){
                            document.getElementById("botonmin").click();

        },
        tiposenvio(){
           
        },
        tipoenvioseleccionado() {

            this.documentosanyadidos = [];
            if (this.tipoenvioseleccionado && this.tipoenvioseleccionado.campos) {
                for (let i = 0; i < this.tipoenvioseleccionado.campos.length; i++) {
                    if (this.tipoenvioseleccionado.campos[i].nombre && this.tipoenvioseleccionado.campos[i].desc.includes("Fecha")) {

                        try { this.tipoenvioseleccionado.campos[i - 1].saltolinea = true; }
                        catch (error) {
                            console.log("error", error);
                        }

                    }
                }
            }


        }
    }
})






</script>
<style scoped>
.break {
    flex-basis: 100%;
    height: 0;
}

.flex-br {

    width: 100%;
    height: 0;

}
.Perceptor{
    width:100% !important;
}
.difuminado {
    filter: blur(6px);
    pointer-events: none;
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10 and IE 11 */
    user-select: none;
    /* Standard syntax */
}

.difuminadodos {
    filter: blur(6px);
    pointer-events: none;
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10 and IE 11 */
    user-select: none;
    /* Standard syntax */
}

.spinners {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 9px solid;
    border-color: #d9e3ff;
    border-right-color: #007bff;
    animation: spinner-d3wgkg 1s infinite linear;
    position: absolute;
    z-index: 1000;
    top: 70% !important;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;

}

.p-datepicker-other-month {
color: #bbb !important; /* Color más claro */
opacity: 0.6; /* Opcional, para dar apariencia atenuada */
}

/* Opcional: cambia el fondo al pasar el mouse */
.p-datepicker-other-month:hover {
  background-color: #f0f0f0;
}

@keyframes spinner-d3wgkg {
    to {
        transform: rotate(1turn);
    }
}
</style>